import React from 'react';

import { LandingPageHeroTeaser } from 'components/landing-page-hero-teaser/LandingPageHeroTeaser';
import { LandingPageMarketingCards } from 'components/landing-page-marketing-card/LandingPageMarketingCards';
import { LandingPageRedirectionBanner } from '../components/landing-page-redirection-banner/LandingPageRedirectionBanner';

export const LandingPage: React.FC = () => {
    return (
        <div>
            <LandingPageRedirectionBanner />
            <LandingPageHeroTeaser />
            <LandingPageMarketingCards />
        </div>
    );
};
